module.exports = __webpack_public_path__ + "media/images/loading-e002e522e2e23612fb4a11d3c49e96f2.gif";